import { createUseStyles } from 'react-jss'

export default createUseStyles({
  landscapeLogo: {
    margin: '0 auto 25px',

    '& img': {
      maxHeight: '100%',
      maxWidth: '100%'
    }
  }
})
